import { Icon, IconType } from "assets/icons";

import { ContentWrapper, PaddingConfig } from "components/ContentWrapper";
import { Paragraph } from "components/Paragraph/Paragraph";

import styles from "../styles.module.scss";

type ItemGroupProps = {
  icon?: IconType;
  name: string;
  isActive?: boolean;
  onClick?: () => void;
};

const PADDING: PaddingConfig = {
  paddingTop: 8,
  paddingBottom: 8,
};

export const ProductsGroupItem = (props: ItemGroupProps): JSX.Element => {
  const { icon, name, isActive, onClick } = props;
  return (
    <ContentWrapper
      onClick={onClick}
      paddingConfig={PADDING}
      className={`hoverBg cursor-pointer ${isActive ? styles.isActive : ""}`}
    >
      <div className="flex justify-start items-center relative">
        <div className="absolute -left-2">
          {!!icon ? <Icon type={icon} /> : <div className="w-1" />}
        </div>
        <Paragraph className="pl-3">{name}</Paragraph>
      </div>
    </ContentWrapper>
  );
};
